import './style/index.js';

import _Form from './Form';

export type { FormProps } from './Form';
export type { FormItemProps } from './FormItem';
export * from './hooks/interface';
export * from './type';

export const Form = _Form;
export default Form;
